import React, { useEffect, useState } from 'react';
import ShowContainer from '../../../../components/material-ui/ShowContainer';
import { Box, Stack } from '@mui/material';
import CusLink from '../../../../components/material-ui/CusLink';
import CusTooltip from '../../../../components/material-ui/CusTooltip';

export default function TgCasinoWebHook({ tgCasinoInfo }) {
  const [webHookLink, setWebHookLink] = useState('');

  const apiToken = tgCasinoInfo.apiToken;
  const secretToken = tgCasinoInfo.secretToken;
  const matDomain = tgCasinoInfo.domain;

  useEffect(() => {
    if (!apiToken) return;
    if (!secretToken) return;
    if (!matDomain) return;

    const domainTg = 'https://api.telegram.org/bot';
    const linkWebHook = `${domainTg}${apiToken}/setWebhook?url=${matDomain}/bot/webhook_bot.php&max_connections=100&secret_token=${secretToken}`;

    setWebHookLink(linkWebHook);
  }, [apiToken, secretToken]);

  return (
    <ShowContainer condition={webHookLink}>
      <Stack direction={'row'} gap={1} alignItems={'center'}>
        <CusLink linkComponent="a" target="_blank" href={webHookLink} text="Install WebHook" />

        <Box width={'fit-content'} display={'inline-flex'}>
          <CusTooltip
            text={
              'You only need to follow the link once after saving a new bot or changing the secret token.'
            }
          />
        </Box>
      </Stack>
    </ShowContainer>
  );
}
